import React from "react";
import LogoCarouselCommon from "@isos/feature/dist/Brochureware/components/LogoCarousel";

const LogoCarousel = (props) => <LogoCarouselCommon {...props} />;

export default LogoCarousel;
